// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1YN9Y","text":"SelectPayment_text__2MbG9","title":"SelectPayment_title__2omFi","btn":"SelectPayment_btn__1cu7F"};